import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import './Shares.css';
import SiteHeader from '../../shared/SiteHeader';
import Conversation from '../../shared/Conversation';
import { apiUrl } from '../../api/client';
import type { Conversation as ConversationType } from '../../types/Conversation';

const Shares: React.FC = () => {
  const { shortCode } = useParams<{ shortCode: string }>();
  const [conversation, setConversation] = useState<ConversationType | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    document.title = 'Walk It With Me - Shared Conversation';
  }, []);

  useEffect(() => {
    const fetchSharedConversation = async () => {
      if (!shortCode) {
        setError('No share code provided');
        return;
      }

      try {
        setLoading(true);
        setError('');

        const response = await fetch(apiUrl(`/api/shares/msg/${shortCode}`));

        if (!response.ok) {
          if (response.status === 404) {
            throw new Error('Shared conversation not found');
          } else if (response.status === 410) {
            throw new Error('This shared conversation is no longer available');
          }
          throw new Error('Failed to load shared conversation');
        }

        const data: ConversationType = await response.json();
        setConversation(data);
      } catch (err: unknown) {
        setError(err instanceof Error ? err.message : 'An error occurred');
      } finally {
        setLoading(false);
      }
    };

    void fetchSharedConversation();
  }, [shortCode]);

  return (
    <>
      <SiteHeader />
      <div className="container py-5 shares-page">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-10">
            <div className="shares-body p-3 p-md-4">
              <h2 className="mb-3">Shared Message</h2>
              {conversation && (
                <p className="text-muted mb-4">
                  <strong>{conversation.name}</strong>
                </p>
              )}

              <Conversation
                messages={conversation?.messages ?? []}
                loading={loading}
                error={error}
                emptyMessage="No messages found in this shared conversation."
                autoScroll={false}
                showFeedback={false}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Shares;
